module.exports = __webpack_public_path__ + "media/Audio15_i.19b6be69.wav";